module.exports = __webpack_public_path__ + "img/desalegn.fc5753e6.jpg";